if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.productForm = this.querySelector('product-form');

        this.listenToSellingPlanFormRadioButtonChange();
      }

      get sellingPlansWidgetContainer() {
        return this.querySelector('.selling_plan_app_container');
      }

      get sectionId() {
        return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
      }

      get sellingPlanForms() {
        return this.sellingPlansWidgetContainer.querySelectorAll('.subscribe_and_save-section'); 
      }

      get sellingPlanInput() {
        return this.productForm.querySelector('.selected-selling-plan-id');
      }

      get sellingPlanInputValue() {
        return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
      }

      set selectedPurchaseOption(selectedPurchaseOption) {
        this._selectedPurchaseOption = selectedPurchaseOption;
      }

      get selectedPurchaseOption() {
        return this._selectedPurchaseOption;
      }

      updateSellingPlanInputValue() {
        this.sellingPlanInput.value = this.sellingPlanInputValue;
      }

      handleRadioButtonChange(selectedPurchaseOption) {
        this.selectedPurchaseOption = selectedPurchaseOption;
        this.updateSellingPlanInputValue();
        this.querySelector('.plan-price').textContent = selectedPurchaseOption.dataset.variantPrice;
      }

      get selectedSellingPlanForm() {
        return this._selectedPurchaseOption.closest('.subscribe_and_save-section');
      }

      listenToSellingPlanFormRadioButtonChange() {
        this.sellingPlanForms.forEach((sellingPlanForm) => {
          sellingPlanForm.querySelectorAll('input[type="radio"]')
          .forEach((radio) => {
            radio.addEventListener('change', (event) => {
              this.handleRadioButtonChange(event.target);
            });
          });
        });
      }
    }
  );
}
